import { values } from './_helpers'

const _enum = {
  colourIntensity: 0,
  colour: 1,
  aromaFlavourIntensity: 2,
  aromaFlavourCharacteristics: 3,
  sweetness: 4,
  acidity: 5,
  tannins: 6,
  alcohol: 7,
  body: 8,
  finish: 9,
  mousse: 10
}

const wsetType = { ..._enum, name: 'wsetType', values: values(_enum) }

export {
  wsetType
}
